$(function () {
	$(document).on('click', '[data-show-share]', function (e) {
		e.preventDefault();

		$(this).closest('.b-share').toggleClass('is-active');
	});
});
